module.exports = __webpack_public_path__ + "img/landingTwo.9a6a141d.jpg";